// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5910) return "static/chunks/5910.f6133d14f03eb848.js";
	if (chunkId === 5952) return "static/chunks/5952.e3afbf8c334ab8ab.js";
	if (chunkId === 37) return "static/chunks/37.33eb9c19c48fd2bf.js";
	if (chunkId === 6047) return "static/chunks/6047.2c8d799c8734cde1.js";
	if (chunkId === 2804) return "static/chunks/2804.398287d99cd14a43.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"5647":"ca377847","9066":"dc112a36"}[chunkId] || chunkId) + "-" + {"1318":"941ad66e811bd267","5647":"b9b9d2db7ca20aec","7193":"2fa2c093e9c2f465","8939":"a9e5f5b476fba7b9","9066":"f04c60d5109b227a","9982":"8c84bbf2cbd27539"}[chunkId] + ".js";
};